import {
    GET_QBCC_MANAGEMENT_URL,
    CREATE_QBCC_MANAGEMENT_URL,
    UPDATE_QBCC_MANAGEMENT_URL,
    DELETE_QBCC_MANAGEMENT_URL
} from "../utils/api-url";
import { postCall } from "../utils/network.util";

const handleResponse = (data, onSuccess, onFailure) => {
    if (data && data.status === "SUCCESS") {
        const clientPayload = data.payload;
        if (clientPayload && clientPayload.Status === "SUCCESS") {
            onSuccess(clientPayload.Payload, clientPayload.Message);
            return;
        }
        onFailure(clientPayload && clientPayload.Message ? clientPayload.Message : "Request failed");
        return;
    }
    onFailure("Request failed");
};

export const getQbccManagements = (onSuccess = () => {}, onFailure = () => {}) => {
    return postCall(GET_QBCC_MANAGEMENT_URL, {
        operatorCode: global.operatorCode,
        travelsId: global.travelsId
    }).then((data) => {
        handleResponse(
            data,
            (payload) => {
                const all = payload && payload.travelManagements ? payload.travelManagements : [];
                const filtered = all.filter((item) => item && item.operator_code === global.operatorCode);
                onSuccess(filtered);
            },
            onFailure
        );
    }).catch((reason) => {
        console.error("getQbccManagements failed", reason);
        onFailure("Failed to fetch QBCC users");
    });
};

export const createQbccManagement = ({ phoneNumber, name }, onSuccess = () => {}, onFailure = () => {}) => {
    return postCall(CREATE_QBCC_MANAGEMENT_URL, {
        operatorCode: global.operatorCode,
        travelsId: global.travelsId,
        data: {
            phoneNumber,
            name,
            travelsId: global.travelsId,
            operatorCode: global.operatorCode
        }
    }).then((data) => {
        handleResponse(data, (_, msg) => onSuccess(msg), onFailure);
    }).catch((reason) => {
        console.error("createQbccManagement failed", reason);
        onFailure("Failed to add QBCC user");
    });
};

export const updateQbccManagement = ({ travelManagementId, phoneNumber, name }, onSuccess = () => {}, onFailure = () => {}) => {
    return postCall(UPDATE_QBCC_MANAGEMENT_URL, {
        travelManagementId,
        operatorCode: global.operatorCode,
        travelsId: global.travelsId,
        data: {
            phoneNumber,
            name,
            travelsId: global.travelsId,
            operatorCode: global.operatorCode
        }
    }).then((data) => {
        handleResponse(data, (_, msg) => onSuccess(msg), onFailure);
    }).catch((reason) => {
        console.error("updateQbccManagement failed", reason);
        onFailure("Failed to update QBCC user");
    });
};

export const deleteQbccManagement = ({ travelManagementId }, onSuccess = () => {}, onFailure = () => {}) => {
    return postCall(DELETE_QBCC_MANAGEMENT_URL, {
        operatorCode: global.operatorCode,
        travelsId: global.travelsId,
        travelManagementId
    }).then((data) => {
        handleResponse(data, (_, msg) => onSuccess(msg), onFailure);
    }).catch((reason) => {
        console.error("deleteQbccManagement failed", reason);
        onFailure("Failed to delete QBCC user");
    });
};
